import throttle from 'lodash.throttle';
import g from '#core/global';
import load from '#core/load';
import layout from '#core/layout';


const vanish_$ = '[data-vanish]';
const target_attr = 'data-vanish-target';
const lookaround_attr = 'data-vanish-lookaround';
const visible_attr = 'data-vanish-visible';
const true_s = 'true';
const false_s = 'false';

let has_vanish = false;
let $all_containers = null;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('vanish')) return false;
		
		load.content(() => {
			has_vanish = assign_elements();
			if (!has_vanish) return false;
		});
		load.all(() => {
			has_vanish = assign_elements();
			if (!has_vanish) return false;
			
			init_set_visibility();
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_vanish) return true;
	
	// TODO: do not store objects on load, account for dynamic content
	$all_containers = document.querySelectorAll(vanish_$);
	if (!$all_containers.length) return false;
	
	return true;
}


/**
 * Set visibility
 * @param {element} $container
 */
function set_visibility($container) {
	const target_$ = $container.getAttribute(target_attr);
	const lookaround = $container.getAttribute(lookaround_attr);
	const $targets = document.querySelectorAll(target_$);
	if (!$targets.length) return false;
	
	let show = true;
	Array.from($targets).every($target => {
		const is_intersecting = layout.isIntersecting({
			$element: $target,
			lookaround: parseFloat(lookaround),
		});
		if (!is_intersecting) return true;
		
		show = false;
		return false;
	});
	
	$container.setAttribute(visible_attr, show ? true_s : false_s);
}


/**
 * Set visibility of all vanishers
 */
function set_all_visibility() {
	$all_containers.forEach($el => {
		set_visibility($el);
	});
}


/**
 * Watch for intersection changes
 */
function init_set_visibility() {
	window.addEventListener(g.scroll_e, throttle(() => {
		set_all_visibility();
	}, 250));
	window.addEventListener(g.resize_e, throttle(() => {
		set_all_visibility();
	}, 250));
	
	const observer = new MutationObserver(() => {
		set_all_visibility();
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
}
